import React, { useEffect } from "react";
import classNames from "classnames";
import { useLocation } from "react-router";
import { makeStyles } from "@material-ui/core/styles";
import Button from "components/CustomButtons/Button.js";
import ListItem from "@material-ui/core/ListItem";
import List from "@material-ui/core/List";
import { headApi } from "utils/headApi";
import { imgApi } from "utils/imgApi";
import Header from "views/Main/MainHeader.js";
// import Header from "views/Admin/Adminheader.js";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Check from "@material-ui/icons/Check";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import CardFooter from "components/Card/CardFooter.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import PinDrop from "@material-ui/icons/PinDrop";
import InfoArea from "components/InfoArea/InfoArea.js";
import Phone from "@material-ui/icons/Phone";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import Card from "components/Card/Card.js";
import Muted from "components/Typography/Muted.js";
import { SiWhatsapp } from "react-icons/si";
import { IoLogoWhatsapp } from "react-icons/io";
import { ImMobile } from "react-icons/im";
import Footer from "components/Footer/Footer.js";
import Slide from "@material-ui/core/Slide";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
// import LibraryBooks from "@material-ui/icons/LibraryBooks";
import Close from "@material-ui/icons/Close";

import headersStyle from "assets/jss/material-kit-pro-react/views/sectionsSections/headersStyle.js";
import featuresStyle from "assets/jss/material-kit-pro-react/views/sectionsSections/featuresStyle.js";
import projectsStyle from "assets/jss/material-kit-pro-react/views/sectionsSections/projectsStyle.js";
import contactsStyle from "assets/jss/material-kit-pro-react/views/sectionsSections/contactsStyle.js";
import styleFooter from "assets/jss/material-kit-pro-react/views/componentsSections/footerStyle.js";
import javascriptStyles from "assets/jss/material-kit-pro-react/views/componentsSections/javascriptStyles.js";

import bg12 from "assets/img/bg12.jpg";
import axios from "axios";
import face1 from "assets/img/faces/card-profile6-square.jpg";
import face2 from "assets/img/faces/christian.jpg";
import face3 from "assets/img/faces/card-profile4-square.jpg";
import face4 from "assets/img/faces/card-profile1-square.jpg";
import face5 from "assets/img/faces/marc.jpg";
import face6 from "assets/img/faces/kendall.jpg";
import face7 from "assets/img/faces/card-profile5-square.jpg";
import face8 from "assets/img/faces/card-profile2-square.jpg";

const useStyles = makeStyles(headersStyle);
const useSty = makeStyles(featuresStyle);
const useStyl = makeStyles(projectsStyle);
const useStyle = makeStyles(contactsStyle);
const useStyleFooter = makeStyles(styleFooter);
const useStyPop = makeStyles(javascriptStyles);

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

Transition.displayName = "Transition";

export default function Igs({ ...rest }) {
  const [checked, setChecked] = React.useState([]);
  const [userDel, setUserDel] = React.useState([]);
  const [prodDel, setProdDel] = React.useState([]);
  const [about, setAbout] = React.useState([]);
  const [banner, setBanner] = React.useState([]);
  const [returnPolicy, setReturnPolicy] = React.useState([]);
  const [refundPolicy, setRefundPolicy] = React.useState([]);

  const [returnModal, setReurnModal] = React.useState(false);
  const [refundModal, setRefundModal] = React.useState(false);

  const handleToggle = (value) => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];
    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }
    setChecked(newChecked);
  };

  const classes = useStyles();
  const classAbout = useSty();
  const classProduct = useStyl();
  const classContact = useStyle();
  const classFooter = useStyleFooter();
  const classPop = useStyPop();

  const activeSession = sessionStorage.getItem("sessionData");

  // const { state  } = useLocation();

  const search = useLocation().search;
  const a = new URLSearchParams(search).get("a");

  useEffect(() => {
    axios.get(headApi + `/user/byid/${a}`).then((res) => setUserDel(res.data));
  }, []);

  useEffect(() => {
    axios.get(headApi + `/user/AboutUs/${a}`).then((res) => {
      setAbout(res.data);
    });
    axios.get(headApi + `/user/RefundPolicy/${a}`).then((res) => {
      setRefundPolicy(res.data.desc);
    });
    axios.get(headApi + `/user/ReturnPolicy/${a}`).then((res) => {
      setReturnPolicy(res.data.desc);
    });
    axios.get(headApi + `/imageSlider/byid?id=1&userid=${a}`).then((res) => {
      setBanner(res.data);
    });
  }, []);

  useEffect(() => {
    axios
      .get(headApi + `/products/limitList?userid=${a}&active=0&page=1&size=8`)
      .then((res) => setProdDel(res.data.ProductsData));
  }, []);

  return (
    <div className="cd-section" {...rest}>
      {/* HEADER 1 START */}
      <div>
        <Header
          // absolute
          fixed
          // brand="Home"
          color="transparent"
          links={
            <div className={classes.collapse}>
              <List className={classes.list + " " + classes.mlAuto}>
                <ListItem className={classes.listItem}>
                  <Button
                    href="#home"
                    className={classes.navLink}
                    // onClick={(e) => e.preventDefault()}
                    color="transparent"
                  >
                    Home
                  </Button>
                </ListItem>
                <ListItem className={classes.listItem}>
                  <Button
                    href="#about"
                    className={classes.navLink}
                    // onClick={(e) => e.preventDefault()}
                    color="transparent"
                  >
                    About us
                  </Button>
                </ListItem>
                <ListItem className={classes.listItem}>
                  <Button
                    href="#product"
                    className={classes.navLink}
                    // onClick={(e) => e.preventDefault()}
                    color="transparent"
                  >
                    Products
                  </Button>
                </ListItem>
                <ListItem className={classes.listItem}>
                  <Button
                    href="#contact"
                    className={classes.navLink}
                    // onClick={(e) => e.preventDefault()}
                    color="transparent"
                  >
                    Contact us
                  </Button>
                </ListItem>
              </List>
            </div>
          }
          changeColorOnScroll={{
            height: 100,
            color: "info",
          }}
        />
        <div
          className={classes.pageHeader}
          style={{ backgroundImage: `url("${bg12}")` }}
          id="home"
        >
          <div className={classes.container}>
            <GridContainer>
              <GridItem xs={12} sm={8} md={8}>
                <h1 className={classes.title}>{userDel.company}</h1>
                <h4>{banner.description}</h4>
              </GridItem>
            </GridContainer>
          </div>
        </div>
      </div>

      <Card>
        <CardBody>
          <div className={classProduct.projects} id="about">
            <div className={classProduct.container}>
              <GridContainer>
                <GridItem
                  xs={12}
                  sm={10}
                  md={10}
                  className={
                    classAbout.mlAuto +
                    " " +
                    classAbout.mrAuto +
                    " " +
                    classAbout.textCenter
                  }
                >
                  <h2 className={classAbout.title}>
                    {about.titles}
                  </h2>
                  <h5 className={classAbout.description}>{about.desc}</h5>
                </GridItem>
              </GridContainer>
            </div>
          </div>
          <div className={classProduct.projects} id="product">
            <div className={classProduct.container}>
              <GridContainer>
                <GridItem
                  xs={12}
                  sm={8}
                  md={8}
                  className={
                    classProduct.mlAuto +
                    " " +
                    classProduct.mrAuto +
                    " " +
                    classProduct.textCenter
                  }
                >
                  <Muted>
                    <h6>OUR WORK</h6>
                  </Muted>
                  <h2 className={classProduct.title}>
                    Some of Our Awesome Products - 2
                  </h2>
                  <h5 className={classProduct.description}>
                    Customise the order as per your requirements. we make
                    bangles on {"'"}make to{"'"} order. You can get bangles of
                    any size, design and colour
                  </h5>
                  <div className={classProduct.sectionSpace} />
                </GridItem>
              </GridContainer>
              <GridContainer>
                {prodDel &&
                  prodDel.map((prod) => (
                    <GridItem sm={6} md={3} key={prod.id}>
                      <CardHeader image>
                        {/* <a href="#pablo"> */}
                        {/* <img src={cardProduct1} alt="cardProduct" /> */}
                        {prod.design1.img1active === 1 ? (
                          <img
                            src={imgApi + "" + prod.design1.image1}
                            alt="..."
                          />
                        ) : prod.design2.img2active === 1 ? (
                          <img
                            src={imgApi + "" + prod.design2.image2}
                            alt="..."
                          />
                        ) : prod.design3.img3active === 1 ? (
                          <img
                            src={imgApi + "" + prod.design3.image3}
                            alt="..."
                          />
                        ) : prod.design4.img4active === 1 ? (
                          <img
                            src={imgApi + "" + prod.design4.image4}
                            alt="..."
                          />
                        ) : prod.design5.img5active === 1 ? (
                          <img
                            src={imgApi + "" + prod.design5.image5}
                            alt="..."
                          />
                        ) : prod.design6.img6active === 1 ? (
                          <img
                            src={imgApi + "" + prod.design6.image6}
                            alt="..."
                          />
                        ) : (
                          ""
                        )}
                        {/* </a> */}
                      </CardHeader>
                      <CardBody>
                        <h6
                          className={classNames(
                            classes.cardCategory,
                            classes.textRose
                          )}
                        >
                          {prod.cat.description +
                            " " +
                            prod.banglessizemm.description}
                        </h6>
                        <h4 className={classes.cardTitle}>
                          {prod.description}
                        </h4>
                        <div className={classes.cardDescription}>
                          {(prod.metalOption.readygram * prod.sets.pcs).toFixed(
                            4
                          )}{" "}
                          Avg Gram Of {prod.sets.setdesc} {prod.box.boxdesc}{" "}
                          {prod.ctndescription}
                        </div>
                      </CardBody>
                      <CardFooter
                        className={classes.justifyContentBetween}
                        style={{ marginBottom: "15%" }}
                      >
                        <div className={classes.price}>
                          {!activeSession ? (
                            prod.taxCalculation.profitactive === 1 ? (
                              prod.taxCalculation.cash_gst === 1 ? (
                                <>
                                  <h5>
                                    <span style={{ color: "red" }}>
                                      Price ₹{" "}
                                      {(
                                        prod.taxCalculation.taxincl /
                                        prod.box.box
                                      ).toFixed(2)}
                                      /-
                                    </span>
                                  </h5>{" "}
                                </>
                              ) : (
                                <h5>
                                  Price{" "}
                                  <span>
                                    ₹{" "}
                                    {(
                                      prod.taxCalculation.cash / prod.box.box
                                    ).toFixed(2)}
                                    /-*
                                  </span>
                                </h5>
                              )
                            ) : prod.taxCalculation.cash_gst === 1 ? (
                              <>
                                <h5>
                                  <span style={{ color: "#9c27b0" }}>
                                    Price ₹{" "}
                                    {(
                                      prod.taxCalculation.taxincl / prod.box.box
                                    ).toFixed(2)}
                                    /-
                                  </span>
                                </h5>{" "}
                              </>
                            ) : (
                              <h5>
                                Price{" "}
                                <span>
                                  ₹{" "}
                                  {(
                                    prod.taxCalculation.cash / prod.box.box
                                  ).toFixed(2)}
                                  /-*
                                </span>
                              </h5>
                            )
                          ) : (
                            ""
                          )}

                          {activeSession ? (
                            prod.taxCalculation.profitactive === 1 ? (
                              <h6>
                                <span
                                  style={{
                                    textDecoration: "line-through",
                                    color: "red",
                                  }}
                                >
                                  Price ₹
                                  {(
                                    prod.taxCalculation.taxincl / prod.box.box
                                  ).toFixed(2)}
                                  /
                                </span>{" "}
                                ₹{" "}
                                {(
                                  prod.taxCalculation.cash / prod.box.box
                                ).toFixed(2)}
                                /-*
                              </h6>
                            ) : (
                              <h6>
                                <span
                                  style={{
                                    textDecoration: "line-through",
                                    color: "#9c27b0",
                                  }}
                                >
                                  Price ₹
                                  {(
                                    prod.taxCalculation.taxincl / prod.box.box
                                  ).toFixed(2)}
                                  /
                                </span>{" "}
                                ₹{" "}
                                {(
                                  prod.taxCalculation.cash / prod.box.box
                                ).toFixed(2)}
                                /-*
                              </h6>
                            )
                          ) : (
                            ""
                          )}
                        </div>
                      </CardFooter>
                    </GridItem>
                  ))}
              </GridContainer>
            </div>
          </div>
        </CardBody>
      </Card>
      {/* Project 2 END */}
      <div className={classProduct.projects} id="contact">
        <div className={classProduct.container}>
          <GridContainer justify="center" alignItems="center">
            <GridItem xs={12} sm={12} md={10}>
              <Card
              //  className={classContact.card2}
              >
                <form>
                  <CardHeader
                    contact
                    color="info"
                    className={classContact.textCenter}
                  >
                    <h4
                      className={classContact.cardTitle}
                      style={{ color: "#FFF" }}
                    >
                      Contact Us
                    </h4>
                  </CardHeader>
                  <CardBody>
                    <GridContainer>
                      <GridItem xs={12} sm={6} md={4}>
                        <InfoArea
                          className={classContact.infoArea2}
                          title="Call us at"
                          description={
                            <span>
                              {userDel.mobile ? <ImMobile color="red" /> : ""}{" "}
                              {userDel && userDel.mobile ? userDel.mobile : ""}{" "}
                              <br />
                              {userDel.whatsapp ? (
                                <IoLogoWhatsapp color="green" />
                              ) : (
                                ""
                              )}{" "}
                              {userDel && userDel.whatsapp
                                ? userDel.whatsapp
                                : ""}
                            </span>
                          }
                          icon={Phone}
                          iconColor="info"
                        />
                      </GridItem>
                      <GridItem xs={12} sm={6} md={4}>
                        <InfoArea
                          className={classContact.infoArea2}
                          title="Office Address"
                          description={
                            <span>
                              {userDel && userDel.address
                                ? userDel.address
                                : ""}{" "}
                              {userDel && userDel.address1
                                ? userDel.address1
                                : ""}
                              <br />
                              {userDel && userDel.address2
                                ? userDel.address2
                                : ""}{" "}
                              {userDel && userDel.address3
                                ? userDel.address3
                                : ""}{" "}
                              {userDel && userDel.zipcode
                                ? userDel.zipcode
                                : ""}
                              <br />
                              {userDel && userDel.city ? userDel.city : ""}{" "}
                              {userDel && userDel.state ? userDel.state : ""}
                              <br />
                              {userDel && userDel.gstno
                                ? "GSTIN / UIN"
                                : "Aadhar No."}{" "}
                              :{" "}
                              {userDel && userDel.gstno
                                ? userDel.gstno
                                : userDel.aadharno}
                            </span>
                          }
                          icon={PinDrop}
                          iconColor="info"
                        />
                      </GridItem>
                      <GridItem xs={12} sm={6} md={4}>
                        <a
                          href={`https://api.whatsapp.com/send?phone=${userDel.mobile}&text=https://bangles.org.in/%20Hello%20I%20am%20Interested%20in%20your%20Product&app_absent=0`}
                          target="_blank"
                          rel="noreferrer"
                        >
                          <InfoArea
                            className={classContact.infoArea2}
                            title="Click on the Whatsapp icon to get connected with us"
                            // description={
                            //     <span>
                            //         Bld Mihail Kogalniceanu, nr. 8,
                            //         <br /> 7652 Bucharest,
                            //         <br /> Romania
                            //     </span>
                            // }
                            icon={SiWhatsapp}
                            iconColor="success"
                          />
                        </a>
                      </GridItem>
                    </GridContainer>
                    <GridContainer>
                      <GridItem xs={12} sm={6} md={6}>
                        <CustomInput
                          labelText="Full Name"
                          id="first2"
                          formControlProps={{
                            fullWidth: true,
                          }}
                        />
                      </GridItem>
                      <GridItem xs={12} sm={6} md={6}>
                        <CustomInput
                          labelText="Email Address"
                          id="email-address2"
                          formControlProps={{
                            fullWidth: true,
                          }}
                        />
                      </GridItem>
                    </GridContainer>
                    <CustomInput
                      labelText="Your Message"
                      id="message2"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        multiline: true,
                        rows: 5,
                      }}
                    />
                  </CardBody>
                  <CardFooter className={classContact.justifyContentBetween}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          tabIndex={-1}
                          onClick={() => handleToggle(2)}
                          checkedIcon={
                            <Check className={classContact.checkedIcon} />
                          }
                          icon={
                            <Check className={classContact.uncheckedIcon} />
                          }
                          classes={{
                            checked: classContact.checked,
                            root: classContact.checkRoot,
                          }}
                        />
                      }
                      classes={{ label: classContact.label }}
                      label="I'm not a robot"
                    />
                    <Button color="info" className={classContact.pullRight}>
                      Send Message
                    </Button>
                  </CardFooter>
                </form>
              </Card>
            </GridItem>
          </GridContainer>
        </div>
      </div>
      <Footer
        theme="white"
        content={
          <div>
            <div className={classFooter.left}>
              <List className={classFooter.list}>
                <ListItem className={classFooter.inlineBlock}>
                  <a
                    href="#pablo"
                    className={classFooter.block}
                    onClick={() => setReurnModal(true)}
                  >
                    Return Policy
                  </a>
                </ListItem>
                <ListItem className={classFooter.inlineBlock}>
                  <a
                    href="#pablo"
                    className={classFooter.block}
                    onClick={() => setRefundModal(true)}
                  >
                    Refund Policy
                  </a>
                </ListItem>
                {/* <ListItem className={classFooter.inlineBlock}>
                  <a
                    href="#pablo"
                    className={classFooter.block}
                    onClick={(e) => e.preventDefault()}
                  >
                    Discover
                  </a>
                </ListItem>
                <ListItem className={classFooter.inlineBlock}>
                  <a
                    href="#pablo"
                    className={classFooter.block}
                    onClick={(e) => e.preventDefault()}
                  >
                    Payment
                  </a>
                </ListItem> */}
                {/* <ListItem className={classFooter.inlineBlock}>
                  <a
                    href="#pablo"
                    className={classFooter.block}
                    onClick={(e) => e.preventDefault()}
                  >
                    Contact Us
                  </a>
                </ListItem> */}
              </List>
            </div>
            <div className={classFooter.right}>
              Copyright &copy; {1900 + new Date().getYear()}{" "}
              <a
                // href="https://www.creative-tim.com?ref=mkpr-footer-components"
                // target="_blank"
                // rel="noreferrer"
                className={classFooter.aClasses}
              >
                Creative Tim
              </a>{" "}
              All Rights Reserved.
            </div>
          </div>
        }
      >
        <GridContainer>
          <GridItem xs={12} sm={4} md={4}>
            <h5>Our Company</h5>
            <p>
              Creative Tim is a startup that creates design tools that make the
              web development process faster and easier.{" "}
            </p>
            <p>
              We love the web and care deeply for how users interact with a
              digital product. We power businesses and individuals to create
              better looking web projects around the world.{" "}
            </p>
          </GridItem>
          <GridItem xs={12} sm={4} md={4}>
            <h5>Reach Us</h5>
            <div className={classFooter.socialFeed}>
              <div>
                <i className="fab fa-twitter" />
                <p>How to handle ethical disagreements with your clients.</p>
              </div>
              <div>
                <i className="fab fa-twitter" />
                <p>The tangible benefits of designing at 1x pixel density.</p>
              </div>
              <div>
                <i className="fab fa-facebook-square" />
                <p>
                  A collection of 25 stunning sites that you can use for
                  inspiration.
                </p>
              </div>
            </div>
          </GridItem>
          <GridItem xs={12} sm={4} md={4}>
            <h5>Instagram Feed</h5>
            <div className={classFooter.galleryFeed}>
              <img
                src={face1}
                className={classNames(
                  classFooter.img,
                  classFooter.imgRaised,
                  classFooter.imgRounded
                )}
                alt="..."
              />
              <img
                src={face2}
                className={classNames(
                  classFooter.img,
                  classFooter.imgRaised,
                  classFooter.imgRounded
                )}
                alt="..."
              />
              <img
                src={face3}
                className={classNames(
                  classFooter.img,
                  classFooter.imgRaised,
                  classFooter.imgRounded
                )}
                alt="..."
              />
              <img
                src={face4}
                className={classNames(
                  classFooter.img,
                  classFooter.imgRaised,
                  classFooter.imgRounded
                )}
                alt="..."
              />
              <img
                src={face5}
                className={classNames(
                  classFooter.img,
                  classFooter.imgRaised,
                  classFooter.imgRounded
                )}
                alt="..."
              />
              <img
                src={face6}
                className={classNames(
                  classFooter.img,
                  classFooter.imgRaised,
                  classFooter.imgRounded
                )}
                alt="..."
              />
              <img
                src={face7}
                className={classNames(
                  classFooter.img,
                  classFooter.imgRaised,
                  classFooter.imgRounded
                )}
                alt="..."
              />
              <img
                src={face8}
                className={classNames(
                  classFooter.img,
                  classFooter.imgRaised,
                  classFooter.imgRounded
                )}
                alt="..."
              />
            </div>
          </GridItem>
        </GridContainer>
        <GridContainer>
          <GridItem xs={12} sm={6} md={6} lg={4}>
            {/* <Button block round onClick={() => setReurnModal(true)}>
              <LibraryBooks />
              Classic
            </Button> */}
            <Dialog
              classes={{
                root: classPop.modalRoot,
                paper: classPop.modal,
              }}
              open={returnModal}
              TransitionComponent={Transition}
              keepMounted
              onClose={() => setReurnModal(false)}
              aria-labelledby="classic-modal-slide-title"
              aria-describedby="classic-modal-slide-description"
            >
              <DialogTitle
                id="classic-modal-slide-title"
                disableTypography
                className={classPop.modalHeader}
              >
                <Button
                  simple
                  className={classPop.modalCloseButton}
                  key="close"
                  aria-label="Close"
                  onClick={() => setReurnModal(false)}
                >
                  {" "}
                  <Close className={classPop.modalClose} />
                </Button>
                <h4 className={classPop.modalTitle}>Return Policy</h4>
              </DialogTitle>
              <DialogContent
                id="classic-modal-slide-description"
                className={classPop.modalBody}
              >
                <p>{returnPolicy}</p>
              </DialogContent>
              <DialogActions className={classPop.modalFooter}>
                {/* <Button
                  onClick={() => setReurnModal(false)}
                  color="danger"
                  simple
                >
                  Close
                </Button> */}
              </DialogActions>
            </Dialog>
          </GridItem>
          <GridItem xs={12} sm={6} md={6} lg={4}>
            {/* <Button block round onClick={() => setRefundModal(true)}>
              <LibraryBooks />
              Classic
            </Button> */}
            <Dialog
              classes={{
                root: classPop.modalRoot,
                paper: classPop.modal,
              }}
              open={refundModal}
              TransitionComponent={Transition}
              keepMounted
              onClose={() => setRefundModal(false)}
              aria-labelledby="classic-modal-slide-title"
              aria-describedby="classic-modal-slide-description"
            >
              <DialogTitle
                id="classic-modal-slide-title"
                disableTypography
                className={classPop.modalHeader}
              >
                <Button
                  simple
                  className={classPop.modalCloseButton}
                  key="close"
                  aria-label="Close"
                  onClick={() => setRefundModal(false)}
                >
                  {" "}
                  <Close className={classPop.modalClose} />
                </Button>
                <h4 className={classPop.modalTitle}>Refund Policy</h4>
              </DialogTitle>
              <DialogContent
                id="classic-modal-slide-description"
                className={classPop.modalBody}
              >
                <p>{refundPolicy}</p>
              </DialogContent>
              <DialogActions className={classPop.modalFooter}>
                {/* <Button
                  onClick={() => setRefundModal(false)}
                  color="danger"
                  simple
                >
                  Close
                </Button> */}
              </DialogActions>
            </Dialog>
          </GridItem>
        </GridContainer>
      </Footer>
    </div>
  );
}
